import { render, staticRenderFns } from "./SimpleOutcome.vue?vue&type=template&id=2e6ed76d&scoped=true&"
import script from "./SimpleOutcome.vue?vue&type=script&lang=js&"
export * from "./SimpleOutcome.vue?vue&type=script&lang=js&"
import style0 from "./SimpleOutcome.vue?vue&type=style&index=0&id=2e6ed76d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ed76d",
  null
  
)

export default component.exports